import { Button, SectionTitle } from 'src/components'

interface Props {
  icon: any
  title: string
  subtitle: string
  className?: string
  onClick?: () => void
  children?: any
  buttonText?: string
  buttonIcon?: JSX.Element
}

const EmptyState = ({
  icon: Icon,
  title,
  subtitle,
  className,
  buttonText,
  buttonIcon,
  onClick,
  children,
}: Props) => {
  return (
    <div
      className={`flex-column justify-center h-full w-full items-center box-content ${className}`}
    >
      {Icon}
      <SectionTitle
        {...{ title, subtitle, theme: 'header', className: 'mt-[20px]' }}
      />
      {children && children}
      {!children && onClick && (
        <Button
          theme='secondary-ghost'
          onClick={onClick}
          icon={buttonIcon}
          size='m'
        >
          {buttonText}
        </Button>
      )}
    </div>
  )
}

export default EmptyState
